window.addEventListener('load', event => {
    let shareButtons = document.querySelectorAll('[data-prompt-share]');

    for (let button of shareButtons) {
        let lock = false;

        button.addEventListener('click', async (event) => {
            event.preventDefault();

            if (!lock) {
                lock = true;
                let shareLink = button.dataset.shareLink;
                let shareText = button.dataset.shareText;

                const shareData = {
                    title: 'Check this out!',
                    text: shareText,
                    url: shareLink
                };

                // Check if navigator.share is supported
                if (navigator.share) {
                    try {
                        await navigator.share(shareData);
                        console.log('Shared successfully!');
                    } catch (error) {
                        console.error('Sharing failed', error);
                    }
                    lock = false;
                } else {
                    // Fallback: Copy link to clipboard if share is not supported
                    const innerContent = button.innerHTML;
                    try {
                        await navigator.clipboard.writeText(shareLink);
                        button.innerHTML = 'Copied URL!';
                    } catch (error) {
                        console.error('Failed to copy text', error);
                    }

                    // Reset button content after 2 seconds
                    setTimeout(() => {
                        button.innerHTML = innerContent;
                        lock = false;
                    }, 2000);
                }
            }
        });
    }
});
